<template>
  <div id="app">
    <navigation />
    <transition :name="transition" appear>
      <router-view :key="$route.name" />
    </transition>
    <div 
      v-if="cart.length > 0" 
      class="text-white text-2xl lg:text-4xl fixed left-0 bottom-0 p-4 z-50 mix-blend-exclusion"
      @mouseenter.prevent="$root.$emit('changeCursor', '&#x25C6;')" @mouseleave="$root.$emit('resetCursor')"
    >
      <router-link @click="$root.$emit('pageTitle', '')" :to="{ name: 'cart' }" class="flex items-baseline">
         <img class="h-6" src="./assets/basket.svg" alt="Panier"><span class="-translate-y-[2px] lg:translate-y-0">&nbsp;{{ cart.length }}</span>
      </router-link>
    </div>
    <custom-cursor />
  </div>
</template>

<script>
const Navigation = () =>
  import(/* webpackChunkName: "Navigation" */ "@/components/Navigation.vue");
const CustomCursor = () =>
  import(/* webpackChunkName: "Cursor" */ "@/components/Cursor.vue");
import { mapState } from "vuex";
export default {
  name: "App",
  metaInfo() {
    return {
      titleTemplate: "Squadra B" + " %s",
    };
  },
  components: {
    Navigation,
    CustomCursor
  },
  data() {
    return {
      transition: 'fade'
    }
  },
  mounted() {
    document.body.style.height = window.innerHeight + 'px';
    window.addEventListener('resize', () => {
       document.body.style.height = window.innerHeight + 'px';
    });
  },
  watch: {
    $route(to, from) {
      if(to.name == 'home' || to.name == 'item' || to.name == 'about') {
        this.transition = 'slide-right'
      }
      if(to.name == 'furniture' && (from.name == 'about' || from.name == 'item')) {
        this.transition = 'slide-left'
      }
      if(to.name == 'item' && from.name == 'about') {
        this.transition = 'slide-left'
      }
      if(from.name == 'home') {
        this.transition = 'slide-left'
      }
      if(!from.name) {
        this.transition = 'fade'
      }
    }
  },
  computed: { 
    ...mapState(["site", "cart"])
  },
  created() {
    this.$store.dispatch("loadSite");
    this.$store.dispatch("loadHome");
  },
};
</script>